import React from 'react';
import { X } from '@olxbr/ds-icons';
import { VisuallyHidden } from '../../../VisuallyHidden';
import { Text } from '../../../Text';
import * as S from './styles';
const CloseIcon = () => React.createElement(X, { size: "24", color: "var(--color-neutral-130)" });
export const TopBar = ({ testId, closeCallback, title }) => {
    return (React.createElement(S.TopBar, null,
        React.createElement(Text.TitleSmall, { color: "--color-neutral-130" }, title),
        React.createElement(S.ButtonWrapper, { "data-ds-component": "DS-Modal-Button", "data-testid": testId ? `${testId}-closeButton` : 'closeButton', onClick: closeCallback, type: "button" },
            React.createElement(VisuallyHidden, null, "Fechar janela de di\u00E1logo"),
            React.createElement(CloseIcon, null))));
};
